module.exports = __webpack_public_path__ + "img/loader-2_food.c4cb9abc.gif";